import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/link.svg'


const _withScopeId = n => (_pushScopeId("data-v-ce6a5eee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reco" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Recommandations HAS (2019)")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "picto-link",
  src: _imports_0
}, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Recommandations HAS (2019)")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "picto-link",
  src: _imports_0
}, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "small-reco" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, [
      (!_ctx.isMobile())
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: `${_ctx.recoHas}`,
            target: "blank"
          }, _hoisted_5, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: 'medics://viewer?m_source=' + _ctx.recoHas
          }, _hoisted_9, 8, _hoisted_6))
    ]),
    _createElementVNode("div", _hoisted_10, [
      (!_ctx.isMobile())
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: `${_ctx.recoHasSmall}`,
            target: "blank",
            class: "underline"
          }, "https://www.has-sante.fr/upload/docs/application/pdf/2019-07/synthese_hpv.pdf", 8, _hoisted_11))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: 'medics://viewer?m_source=' + _ctx.recoHasSmall,
            class: "underline"
          }, "https://www.has-sante.fr/upload/docs/application/pdf/2019-07/synthese_hpv.pdf", 8, _hoisted_12))
    ])
  ]))
}